(function () {
    'use strict';

    angular
        .module('app')
        .factory('ExportService',
            function (GridUtil) {

                var exportFormatters = {
                    'dateShort': function(value) {
                        return value !== null ? $filter('date')(value, 'MM/dd/yyyy') : '';
                    }
                };

                var excelExportFormatResults = function (exportToExcelArgs, date) {

                    var searchResults = exportToExcelArgs.searchResults;

                    var dateCheckRegex = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)/;

                    for (var i = 0; i < searchResults.length; i++) {
                        angular.forEach(searchResults[i], function (value, key) {
                            if (value == null) {
                                searchResults[i][key] = '';
                            } else {
                                if (dateCheckRegex.test(value)) {

                                    var colDef = _.findWhere(exportToExcelArgs.columnDefs, { field: key });

                                    if (colDef && colDef.cellRendererName === 'dateParseNonLocal') {
                                        searchResults[i][key] = GridUtil.dateParseNonLocal(value, date);
                                    } else {
                                        searchResults[i][key] = GridUtil.dateParse(value, date);
                                    }
                                }
                                else if (value === true || value === false) {
                                    searchResults[i][key] = GridUtil.check(value);
                                }
                            }
                        });
                    }

                    return searchResults;
                };

                var excelExportBuildExportSelectString = function (exportToExcelArgs) {

                    if (exportToExcelArgs.explicitExportColumns) {

                        return _.chain(exportToExcelArgs.columnDefs)
                            .filter(function (col) {
                                if (col.notExportable) {
                                    return false;
                                }
                                return col.includeInExport;
                            })
                            .filter(function (col) {
                                if (_.isFunction(exportToExcelArgs.exportColumnFilter)) {
                                    return exportToExcelArgs.exportColumnFilter(col);
                                }
                                return true;
                            })
                            .sortBy(function (col) {
                                return col.exportOrder;
                            })
                            .map(function (col) {
                                return '[' + col.field + '] AS [' + col.exportName + ']';
                            })
                            .value()
                            .join(',');
                    }

                    return _.chain(exportToExcelArgs.columns)
                        .filter(function (col) {
                            var colDef = _.find(exportToExcelArgs.columnDefs,
                                function (def) {
                                    return def.field === col.colId;
                                });
                            if (colDef && colDef.notExportable) {
                                return false;
                            }
                            if (colDef && colDef.requiredForExport) {
                                return true;
                            }
                            return !col.hide;
                        })
                        .map(function (col) {
                            var headerName = col.field;
                            var colDef = _.find(exportToExcelArgs.columnDefs,
                                function (def) {
                                    return def.field === col.colId;
                                });
                            if (colDef) {
                                headerName = colDef.headerName;
                            }
                            return '[' + col.colId + '] AS [' + headerName + ']';
                        })
                        .value()
                        .join(',');
                };

                return {
                    excelExport: function (exportToExcelArgs, date) {

                        var searchResults = excelExportFormatResults(exportToExcelArgs, date);

                        var selectString = excelExportBuildExportSelectString(exportToExcelArgs);

                        var fileName = exportToExcelArgs.reportName.replace(/\s/g, '-') + '-Export';

                        var settings = $.extend(true, {}, { headers: true, sheetid: 'Sheet1' }, exportToExcelArgs.settings);
                        
                        var alaSqlArgs = [
                            settings,
                            searchResults
                        ];

                        return alasql.promise('SELECT ' + selectString + ' INTO XLSX("' + fileName + '.xlsx",?) FROM ?', alaSqlArgs);
                    }
                };
            });
})();
